import { wellnessPillars } from "@/data/content";
import { Leaf } from "lucide-react";

export default function WellnessLaunch() {
  return (
    <section id="wellness" className="relative py-20 md:py-28 bg-[var(--aura-teal)] text-[var(--aura-ivory)] overflow-hidden">
      <div
        className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full opacity-25 blur-3xl pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(142,170,156,0.9), transparent 60%)",
        }}
      />
      <div
        className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full opacity-20 blur-3xl pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(212,175,55,0.9), transparent 60%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[var(--aura-ivory)]/25 bg-white/5">
            <Leaf size={14} />
            <span className="font-ui text-xs uppercase tracking-[0.2em]">
              Launching first
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            Launching with lifestyle and wellness events
          </h2>
          <p className="mt-5 font-body text-[var(--aura-ivory)]/85 leading-relaxed">
            Our first event series is designed for working professionals who
            want practical tools for healthier routines, better energy, mental
            calm, and sustainable habits.
          </p>
          <p className="mt-6 font-body text-xs text-[var(--aura-ivory)]/60 max-w-md">
            Wellness sessions provide general lifestyle education. They do not
            diagnose, treat, cure, or replace medical advice from qualified
            healthcare professionals.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          {wellnessPillars.map((p, i) => (
            <div
              key={p.title}
              className="rounded-2xl p-6 border border-white/10 bg-white/[0.04] hover:bg-white/[0.07] transition-colors backdrop-blur-sm"
            >
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-full border border-white/25 flex items-center justify-center font-ui text-xs">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-xl">{p.title}</h3>
              </div>
              <p className="mt-3 font-body text-sm text-[var(--aura-ivory)]/80 leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
